module.exports = __webpack_public_path__ + "img/feature-floating-controls.8ab3ade.svg";